
define('text!src/plugins/summaryWidget/src/views/summary-widget.html',[],function () { return '<div class="w-summary-widget s-status-no-data">\n    <a class="t-summary-widget l-summary-widget s-summary-widget labeled">\n        <span class="label widget-label">Loading...</span>\n    </a>\n</div>\n';});

